<div class="container-fluid" style="margin-top: 5% !important;" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'&&!clienteserviceParam.rolABFlag">
  <div class="card mt-1" style="width: 797px !important;">
    <span class="text-center" style="color: #de2460">
      <i class="bi bi-circle-fill mr-3 " style="font-size: 8px"></i>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteConCodigoBantrab === 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente deben ser registrados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor deben ser registrados
        </span>
      </span>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'
        && clientData.cliente.existeClienteConCodigoBantrab !== 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente se encuentran desactualizados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor se encuentran desactualizados
        </span>
      </span>
    </span>
  </div>
</div>
<div class="container-fluid">
    <h3>Datos de patrono</h3>
    <h4>Ingresa o actualiza tus datos de patrono</h4>
    <form [formGroup]="patronesForm">
        <div class="segmentoingreso">
            <div class="row">
                 <!-- Estado mas de un patron -->
                <div class="col-md-8" *ngIf="precalificationData.segmento === 'E'">
                    <div class="form-group p-0 mt-0">
                      <p>Seleccione Patrono</p>
                      <select class="form-control" formControlName="codigoPatronoSelected" (change)="changeChief(this.$event)">
                        <option *ngFor=" let patrono of patronos" [ngValue]="patrono">{{ patrono.nombrePatrono }}</option>
                      </select>
                    </div>
                  </div>
             <!-- PRIVADA -->
                 <div class="col-md-8" *ngIf="precalificationData.segmento == 'P'">
                    <p>Nombre de patrono</p>
                     <div class="input-group">
                        <input type="text" 
                            class="form-control"
                            formControlName="nombrePatrono" 
                            style="border-style: solid none solid solid !important;" 
                            #nombrepatrono 
                        >
                        <div class="input-group-btn">
                            <button 
                                class="btn" 
                                (click)="consultaPatrono()"
                                >
                                <span><img src="../../assets/icons/lupa.png" height="18px"></span>
                            </button>
                        </div>
                        <span class="form-error" style="margin-top: 5px !important;width:100%;"
                            *ngIf="patronesForm.get('nombrePatrono').hasError('required')&& submitAttempt">Este campo
                            obligatorio</span>
                        <span class="form-error" style="margin-top: 5px !important;width:100%;"
                            *ngIf="patronesForm.get('nombrePatrono').hasError('pattern')&& submitAttempt">Formato invalido</span>
                    </div>
                </div>
              <!-- Pago voluntario select -->
              <div class="col-md-8" *ngIf="precalificationData.segmento === 'PV'">
                <div class="form-group p-0 mt-0">
                  <p>Seleccione Patrono</p>
                  <select class="form-control" formControlName="codigoPatrono" (change)="consultaPatrono()">
                    <option *ngFor=" let patrono of patronos" value="{{patrono.numeroPatrono}}">{{ patrono.nombrePatrono }}</option>
                  </select>
                </div>
              </div>
              <!-- End Pago voluntario select -->
            </div>
            <div class="row">
                <div class="col-md-4" *ngIf="mostrarFecha">
                    <div class="form-group">
                        <label for="exampleInputEmail1">Fecha de ingreso</label>
                        <input [textMask]="{mask: mask}" formControlName="fechaingreso" class="form-control"
                            id="exampleInputEmail1" type="text" placeholder="dd/mm/aaaa" />
                        <span class="form-error" style="margin-top: 5px !important;width:100%;"
                            *ngIf="patronesForm.get('fechaingreso').hasError('required')&& submitAttempt">Este campo es
                            obligatorio</span>
                        <span class="form-error" style="margin-top: 5px !important;width:100%;"
                            *ngIf="patronesForm.get('fechaingreso').hasError('pattern')&& submitAttempt">Formato invalido</span>

                    </div>
                </div>
                <div class="col-md-4" *ngIf="!clienteserviceParam.rolABFlag && precalificationData.segmento =='E'">
                  <div class="form-group">
                      <label for="exampleFormControlSelect1">Renglón presupuestado</label>
                      <select class="form-control" formControlName="reglon" name="plazo">
                          <option value="0" hidden>Seleccione un reglon</option>
                          <option value="11">11</option>
                          <option value="21">21</option>
                          <option value="22">22</option>
                          <option value="31">31</option>
                      </select>
                  </div>
              </div>
              <div class="col-md-4" *ngIf="precalificationData.segmento !== 'E'">
                <div class="form-group">
                  <label for="exampleFormControlSelect1">Salario base</label>
                  <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Q</span>
                    </div>
                    <input type="text" formControlName="salarioBase" (blur)="changeIngresos($event)"
                      class="form-control"  [readonly]="cargaindicesbool && precalificationData.segmento=='E'" name="salario">
                </div>
                </div>
            </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div style="text-align: left;" *ngIf="clienteserviceParam.tipoPrecalificacion !== 'tarjeta_credito'">
                    <button class="btn round-button-back" (click)="goBack()">Regresar</button>
                </div>
            </div>
            <div class="col-md-6">
                <div style="text-align: right;">
                    <button class="btn round-button" (click)="goToIngresos()">Continuar</button>
                </div>
            </div>
        </div>
    </form>
</div>
